import { connect } from "react-redux";
import { selectHappinessAmount } from "../../selectors/selectHappinessInfo";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { componentFromType } from "../generic/componentFromType";
import { IdTooltipAnchor, withDynamicTooltip } from "../tooltip";
import { Happiness } from "./Happiness";
import { HudHappinessTooltip } from "./HudHappinessTooltip";
var mapState = function (state) {
    var happiness = selectHappinessAmount(state);
    return { happiness: happiness };
};
export var HudHappiness = connect(mapState)(HOCHudComponent(withDynamicTooltip({
    anchor: IdTooltipAnchor.TopLeft,
    component: componentFromType(HudHappinessTooltip),
})(Happiness)));



//////////////////
// WEBPACK FOOTER
// ./src/features/happiness/HudHappiness.tsx
// module id = 2304
// module chunks = 3